import React from 'react';

import BudgetTagsCell from '../budget_tags/BudgetTagsCell';

import NumberFormat from 'CommonComponents/LocalisedNumberFormat';
import TextButton from 'CommonComponents/TextButton';

import BarsTwoIcon from 'Assets/icons/bars-2.svg';
import ChevronDownIcon from 'Assets/icons/chevron-down.svg';
import TrashIcon from 'Assets/icons/trash.svg';

function ExpenseItem(props) {
    const handlePriceChange = (value) => {
        var newValue = value.floatValue !== undefined ? value.floatValue : 0;
        props.updateExpense(newValue, props.expenseKey, 'price');
    };
    const handleItemNameChange = (value, index) => {
        props.updateExpense(value, props.expenseKey, 'amount', 'name', index);
    };
    const handleFocus = (event) => event.target.select();
    const textColumnBasis = props.showBudgetTags ? 'tw-basis-2/12' : 'tw-basis-3/12';
    return (
        <div className="tw-flex tw-bg-[#f1f1f1]">
            <div className="tw-basis-12 tw-shrink-0 tw-flex tw-items-center tw-justify-center tw-p-3 tw-border-r-2 tw-bg-inherit">
                <button type="button" className="tw-cursor-grab">
                    <BarsTwoIcon className="tw-w-3 tw-h-3" />
                </button>
            </div>
            {'template_divider' === props.type ? (
                <>
                    <div className="tw-basis-full tw-p-3 tw-border-r-2 tw-bg-inherit">
                        <input
                            className="tw-border-0 text-input !tw-bg-white"
                            type="text"
                            value={props.name}
                            onChange={(e) => props.updateExpense(e.target.value, props.expenseKey, 'name')}
                        />
                    </div>
                    <div className="tw-basis-12 tw-shrink-0 tw-flex tw-items-center tw-gap-x-2 tw-justify-center tw-p-3 tw-bg-inherit">
                        <button type="button" onClick={(e) => props.handleDeleteExpense(props.expenseKey)}>
                            <TrashIcon className="tw-w-3 tw-h-3" />
                        </button>
                        <button onClick={props.handleClick}>
                            <ChevronDownIcon className="tw-w-2.5 tw-h-2.5" />
                        </button>
                    </div>
                </>
            ) : (
                <>
                    <div className="tw-basis-full tw-flex tw-items-center">
                        <div className={`${textColumnBasis} tw-p-3 tw-border-r-2 tw-bg-inherit`}>
                            <input
                                className="tw-border-0 text-input !tw-bg-white"
                                type="text"
                                value={props.name}
                                onChange={(e) => props.updateExpense(e.target.value, props.expenseKey, 'name')}
                            />
                        </div>
                        <div className={`${textColumnBasis} tw-p-3 tw-border-r-2 tw-bg-inherit`}>
                            <input
                                className="tw-border-0 text-input !tw-bg-white"
                                type="text"
                                value={props.description}
                                onChange={(e) => props.updateExpense(e.target.value, props.expenseKey, 'description')}
                            />
                        </div>
                        <div className="tw-basis-2/12 tw-p-3 tw-border-r-2 tw-bg-inherit">
                            <NumberFormat
                                value={props.price}
                                defaultValue={0}
                                className="tw-border-0 text-input !tw-bg-white"
                                decimalScale={2}
                                thousandSeparator={true}
                                inputMode="numeric"
                                allowNegative={false}
                                onValueChange={handlePriceChange}
                                onFocus={handleFocus}
                            />
                        </div>
                        <div className="tw-basis-4/12 tw-grid tw-grid-cols-2">
                            {props.maxQuantitiesColumns &&
                                [...Array(props.maxQuantitiesColumns).keys()].map((index) => (
                                    <div key={`${props.updateExpense.id}-${index}`} className="tw-flex tw-items-center tw-p-3 tw-border-r-2 tw-bg-inherit">
                                        {props.amount && props.amount[index] ? (
                                            <div className="tw-flex tw-items-center tw-space-x-2 tw-w-full">
                                                <input
                                                    className="tw-border-0 text-input !tw-bg-white"
                                                    type="text"
                                                    placeholder={$t('Quantity Name')}
                                                    value={props.amount[index].name}
                                                    onChange={(e) => handleItemNameChange(e.target.value, index)}
                                                />
                                                {(!props.commitmentsExists || props.isNewExpense) && (
                                                    <button type="button">
                                                        <TrashIcon className="tw-w-3 tw-h-3" onClick={() => props.handleDeleteQuantityColumn(index)} />
                                                    </button>
                                                )}
                                            </div>
                                        ) : (
                                            <TextButton
                                                variant="primary"
                                                disabled={index > 0 && !props.amount[index - 1]}
                                                onClick={() => props.handleAddQuantityColumn()}
                                            >
                                                {$t('Add Quantity')}
                                            </TextButton>
                                        )}
                                    </div>
                                ))}
                        </div>
                        {props.showBudgetTags && (
                            <div className="tw-basis-2/12 tw-p-3 tw-border-r-2 tw-bg-inherit">
                                <BudgetTagsCell
                                    cell={props.budgetTags}
                                    isNew={props.isNewExpense}
                                    onOpen={() => props.onOpenBudgetTags(props.expenseId, props.name)}
                                />
                            </div>
                        )}
                    </div>
                    <div className="tw-basis-12 tw-shrink-0 tw-flex tw-items-center tw-justify-center tw-p-3 tw-bg-inherit">
                        {(!props.expenseCommitmentExists || props.isNewExpense) && (
                            <button type="button" onClick={(e) => props.handleDeleteExpense(props.expenseKey)}>
                                <TrashIcon className="tw-w-3 tw-h-3" />
                            </button>
                        )}
                    </div>
                </>
            )}
        </div>
    );
}

export default React.memo(ExpenseItem);
